import React, { Component } from 'react';
import { withRouter, Link } from 'react-router-dom';
import logo from '../assets/logo.png'; // Your QR code logo
import logo2 from '../assets/logo2.png'; // Logo 2
import QRCode from 'qrcode'; // Import the qrcode package
import './CSS/Login.css'; // Assuming you want to reuse the same CSS

class ShowTokens extends Component {
  constructor(props) {
    super(props);
    this.state = {
      token: null,
      copySuccess: '',
      qrCodeUrl: '', // State to hold the QR code URL
    };
  }

  componentDidMount() {
    const { location } = this.props;

    // Try to access token from location.state
    const token = location.state?.token;

    if (token) {
      // Set token if received from location.state
      this.setState({ token }, () => this.generateQRCode(token)); // Generate QR code after token is set
    } else {
      // If no token in location.state, fallback to token stored in localStorage
      const tokenFromStorage = localStorage.getItem('token');
      if (tokenFromStorage) {
        this.setState({ token: tokenFromStorage }, () => this.generateQRCode(tokenFromStorage));
      }
    }
  }

  // Function to generate QR code with logo in the center
  generateQRCode = (token) => {
    QRCode.toDataURL(token)
      .then((url) => {
        this.addLogoToQRCode(url);
      })
      .catch((err) => {
        console.error('Error generating QR code', err);
      });
  };

  // Function to add logo to QR code
  addLogoToQRCode = (url) => {
    const logoImage = new Image();
    logoImage.src = logo;
    logoImage.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      const qrImage = new Image();
      qrImage.src = url;
      qrImage.onload = () => {
        canvas.width = qrImage.width;
        canvas.height = qrImage.height;

        // Draw QR code image
        ctx.drawImage(qrImage, 0, 0);

        // Adjust the logo size to make it bigger
        const logoSize = qrImage.width / 4; // Adjust this value for bigger logo
        const logoX = (qrImage.width - logoSize) / 2;
        const logoY = (qrImage.height - logoSize) / 2;

        // Draw logo at the center of the QR code
        ctx.drawImage(logoImage, logoX, logoY, logoSize, logoSize);

        // Set the final image with logo as the QR code
        this.setState({ qrCodeUrl: canvas.toDataURL() });
      };
    };
  };

  // Copy token to clipboard
  copyToClipboard = () => {
    const textarea = document.querySelector('#tokenTextarea');
    textarea.select();
    document.execCommand('copy');
    this.setState({ copySuccess: 'Token copied to clipboard!' });
  };

  handleLogout = () => {
    // Clear token from localStorage
    localStorage.removeItem('token');
    // Redirect to the login page
    this.props.history.push('/login2');
  };

  handleDownloadQRCode = () => {
    const { qrCodeUrl } = this.state;
    const link = document.createElement('a');
    link.href = qrCodeUrl;
    link.download = 'token_qr_code.png'; // The name of the downloaded file
    link.click();
  };

  render() {
    const { token, copySuccess, qrCodeUrl } = this.state;

    return (
      <div className="token-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className='logo' src={logo} alt="Logo" />
          <h2>Your Generated Token</h2>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  {token ? (
                    <>
                      {/* Display token in text area */}
                      <textarea
                        id="tokenTextarea"
                        rows="5"
                        cols="50"
                        className="form-control"
                        value={token}
                        readOnly
                      />
                      <button
                        onClick={this.copyToClipboard}
                        className="btn btn-dark mt-3"
                      >
                        Copy Token
                      </button>
                      {copySuccess && <div className="alert alert-success mt-3">{copySuccess}</div>}

                      {/* Display QR code with logo */}
                      <div className="mt-3">
                        {qrCodeUrl && (
                          <div>
                            <img src={qrCodeUrl} alt="QR Code" style={{ width: '250px', height: '250px' }} />
                          </div>
                        )}
                      </div>
                      {/* Download QR Code Button */}
                      {qrCodeUrl && (
                        <button
                          onClick={this.handleDownloadQRCode}
                          className="btn btn-primary mt-3"
                        >
                          Download QR Code
                        </button>
                      )}
                    </>
                  ) : (
                    <p>No token available. Please log in or register.</p>
                  )}
                  <div className="text-center mt-3">
                    <Link to='/conduct-transaction'>Want to store your token on our blockchain?</Link>
                    <br />
                    <button
                      onClick={this.handleLogout}
                      className="btn btn-danger mt-3"
                    >
                      Logout
                    </button>
                    <br />
                    <div>Powered by</div>
                    <img className='logo2' src={logo2} alt="Logo 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ShowTokens);
